import { useState, useCallback, memo } from 'react'
import { TopBar } from './top-bar'
import { Sidebar } from './sidebar'
import { MobileMenu } from './mobile-menu'
import { SaleBanner } from './sale-banner'

interface MainLayoutProps {
  children: React.ReactNode
}

export const MainLayout = memo(function MainLayout({ children }: MainLayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const handleOpenMenu = useCallback(() => setIsMobileMenuOpen(true), [])
  const handleCloseMenu = useCallback(() => setIsMobileMenuOpen(false), [])

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Sale Banner */}
      <SaleBanner />
      
      {/* Fixed header area - never scrolls */}
      <div className="shrink-0 z-40 bg-[#0a0a0a]">
        <TopBar onMenuClick={handleOpenMenu} />
      </div>
      
      {/* Content area - fills remaining space */}
      <div className="flex flex-1 min-h-0 overflow-hidden">
        {/* Sidebar - hidden on mobile */}
        <div className="hidden md:block h-full shrink-0 overflow-hidden">
          <Sidebar />
        </div>
        {/* Main content - this is where scrolling happens */}
        <main 
          className="flex-1 overflow-y-auto overflow-x-hidden overscroll-none"
          style={{ 
            WebkitOverflowScrolling: 'touch',
            overscrollBehavior: 'none',
          }}
        >
          <div className="animate-page-in">{children}</div>
        </main>
      </div>

      {/* Mobile menu drawer */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={handleCloseMenu} />
    </div>
  )
})
